import React, { useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const FAQsComponents = (props) => {
    const { setModule, module, isSmallScreen, question, answer } = props;

    return (
        <div>
            <div className="moduleHeading" onClick={(e) => setModule(!module)}>
                <div style={{ width: isSmallScreen ? "100%" : "100%" }}>
                    <div style={{ fontSize: isSmallScreen ? "1rem" : "1.2rem", fontWeight: 600 }}>{question}</div>
                </div>
                <div style={{ width: "30%" }}>
                    {
                        module ?
                            <ExpandLessIcon style={{ float: "right" }} />
                            :
                            <ExpandMoreIcon style={{ float: "right" }} />
                    }
                </div>
            </div>
            {module &&
                <div style={{ margin: "1.5% 2.5% 1.5% 2.5%" }}>
                    <div style={{ margin: "20px 0 10px 0" }}>
                        {answer === "Module15"
                            ?
                            <div>
                                Leading professional experts and top Microsoft instructors collaborated to build the content and learning experience for this program.
                                <br/><br/>
                                The only program that covers the three most widely used cloud platforms as part of the same curriculum is the multi-cloud approach. Every other participant provides one or more platforms as an optional or elective module.
                                <br/><br/>
                                <b>Mentorships</b>: The only program that provides co-creation of mentored projects with leading product firms such as Flipkart, Uber, and BlinkIt. These contribute to the development of industry-demanding skills.
                                <br/><br/>
                                In addition, the PaperLive Learning Experience makes sure you build a large peer network, relationships with industry instructors, and plenty of career support—all in all, an all-encompassing and immersive online and offline learning experience!
                            </div>
                            :
                            answer
                        }
                    </div>
                </div>
            }
        </div>
    );
}

export default FAQsComponents;
